import { Tenant } from 'src/app/shared/models/tenant';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { WorkspaceService } from 'src/app/shared/services/workspace.service';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { Subscription } from 'rxjs';
import { LocalPersistenceService } from 'src/shared-app-portal/services/local-persistence.service';
import { PreviewForm } from 'src/shared-app-portal/components/lineup-applications/application/application-confirmation/application-confirmation.component';

/**component approximates members.component.html with the application loaded in the route */
@Component({
  selector: 'preview-application-modal',
  templateUrl: 'preview-application-modal.component.html',
  styleUrls: ['preview-application-modal.component.scss'],
  standalone: false
})
export class PreviewApplicationModalComponent implements OnInit, OnDestroy {
  //a type-safe way to open this modal component
  static open = (
    dialog: MatDialog,
    previewForm: PreviewForm,
    isSurvey: boolean = false,
    previewPageId?: string
  ) => {
    dialog.open(PreviewApplicationModalComponent, {
      autoFocus: false,
      width: '960px',
      data: {
        previewForm: previewForm,
        isSurvey: isSurvey,
        previewPageId: previewPageId
      }
    });
  };
  public form: PreviewForm;
  public tenant: Tenant;
  public isApplicationSubmitted: boolean;
  public previewPageId: string;
  private subscription: Subscription;
  logoUrl: string;
  isSurvey: boolean = false;

  constructor(
    private appConfigService: AppConfigService,
    private workspaceService: WorkspaceService,
    private localPersistenceService: LocalPersistenceService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = data.previewForm;
    this.isApplicationSubmitted = false;
    this.previewPageId = data.previewPageId;
    if (data.isSurvey) {
      this.isSurvey = data.isSurvey;
    }
  }

  ngOnInit(): void {
    this.subscription = this.workspaceService.activeWorkspaceLogoUrl.subscribe((result) => {
      //workspace does not have a logo so use tenant logo
      this.logoUrl = result ? result : this.appConfigService.tenant.logoUrl;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  submitApplication = () => {
    this.localPersistenceService.hideSaveForLatterButton();
    this.isApplicationSubmitted = true;
  };
}
